<template>
	<div class="content">
		<div class="container-fluid">
			<div class="row">
				<div class="col-md-12">
					<h1>Akamai overview</h1>
					<div class="row" v-for="product in panamera_akamai_costs_data">
						<div class="col-xl-12">
							<h4 class="card-title">Akamai Usage for  {{product.product_name}}</h4>
							<chart-card :key='product' :chart-data="product.data"
										:chart-options="product.options"
										:responsive-options="product.responsiveOptions"
										chart-type="Bar"
							>
								<template slot="header">
									Y-axis values in million
								</template>
								<template slot="footer">
									<div class="legend">
                                        <span v-for="(service,i) in product.service_name">
                                          <i class="fa fa-circle" :style='{color: colors[i]}'></i>{{ service }}
                                        </span>
										<!-- <i class="fa fa-circle text-warning"></i> AWS Commitment (no VAT) -->
									</div>
								</template>
							</chart-card>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	import ChartCard from 'src/components/Cards/ChartCard.vue'
	import StatsCard from 'src/components/Cards/StatsCard.vue'
	import LTable from 'src/components/Table.vue'
	import axios from 'axios'
	import { colors, formatMoney, formatSimple, chart_base } from 'src/globalVariables'
	import { setInterval } from 'timers';


	Number.prototype.pad = function(size) {
		let s = String(this);
		while (s.length < (size || 2)) {s = "0" + s;}
		return s;
	};

	export default {
		components: {
			LTable,
			ChartCard,
			StatsCard
		},
		created() {
			this.loadData();
			let vm = this;
			setInterval(function(){
				vm.loadData();
			},vm.refresh_minutes*60*1000);
		},
		methods: {
			loadData: function(){
				let today = new Date();
				this.last_update = today.getHours().pad(2) + ":" + today.getMinutes().pad(2) + ":" + today.getSeconds().pad(2);
				console.log('refreshing...');
				axios
					.get('panamera/akamai')
					.then(response => (this.panamera_akamai_costs = response.data));
			},
			refresh_panamera_akamai: function() {
				if (this.panamera_akamai_costs){
					for (let product in this.panamera_akamai_costs) {
						let [labels, series, service_name] = [[], [], []];
						for (let date in this.panamera_akamai_costs[product]){
							labels.push(date.slice(0, -3));
							let i = 0;
							for (let entry in this.panamera_akamai_costs[product][date]) {
								if (service_name.includes(entry) == false) {
									service_name.push(entry)
								}

								if (typeof series[i] == 'undefined') {
									series[i] = [];
								}
								series[i].push(this.panamera_akamai_costs[product][date][entry]);
								i++;
							}
						}
						console.log(labels);
						console.log(series);
						this.panamera_akamai_costs_data.push({
							'product_name': product,
							'service_name': service_name,
							'data': {
								'labels': labels,
								'series': series
							},
							'options': {
								'stackBars': false,
								'seriesBarDistance': 20,
								'seriesBarWidth': 30,
								'axisX': {
									'showGrid': true,
									'showLabel': true
								},
								'axisY': {
									'labelInterpolationFnc': function (n) {
										return n / 1000000
									}
								},
								'height': '245px',
								'chartPadding': {
									'right': 50,
									'left': 50,
									'bottom': 10,
								},
								'tooltip': {
									'tooltipFnc': function(meta, value) {
										return (value)
									},

									tooltipOffset: {
										x: 10,
										y: 70
									},
									'appendToBody': false,
									'transformTooltipTextFnc': function(value) {
										return parseFloat(value).toFixed(2)
									}
								},
							},
							'responsiveOptions': Object.assign({}, chart_base.responsiveOptions),
						});
					}
				}
			}
		},
		watch: {
			panamera_akamai_costs:function(){
				this.refresh_panamera_akamai()
			},
		},
		computed: {

		},
		data () {
			return {
				refresh_minutes: 30,
				last_update: '',
				colors: colors,
				panamera_akamai_costs: {},
				panamera_akamai_costs_total: 0,
				panamera_akamai_costs_data: [],
				editTooltip: 'Edit Task',
				deleteTooltip: 'Remove',
			}
		}
	}
</script>
<style>
	h4.btn {
		background-color: #343a40;
		border-color: #343a40;
		color: #FFFFFF;
	}
</style>
